import { Component, OnInit } from '@angular/core';
import {DataService} from '../../data.service';
import {Meta, Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {ViewportScroller} from '@angular/common';

declare var $: any;
declare var toastr: any;
declare var document: any;
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  submit = false;
  name = '';
  email = '';
  message = '';
  phone = '';
  type = 'Irvinetek';
  mailData: any;
  topic = '';
  showLoder = false;
  constructor(private dataService: DataService, private meta: Meta, private title: Title, private router: Router,
              private scroller: ViewportScroller) {
    document.body.scrollTop = 0;
  }

  ngOnInit(): void {
  }

  validateEmail(email): any {
    // tslint:disable-next-line:max-line-length
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  onSubmit(): void {


    if ( this.name === '' ) {
      toastr.error('Please enter name');
      return;
    }
    if ( this.email === '' ) {
      toastr.error('Please enter email');
      return;
    }
    if ( this.validateEmail(this.email) === false ) {
      toastr.error('Please enter valid email');
      return;
    }
    if ( this.topic === '' ) {
      toastr.error('Please select topic');
      return;
    }
    if ( this.message === '' ) {
      toastr.error('Please enter message');
      return;
    }
    console.log(this.name, this.email, this.message, this.phone, this.topic);

    this.submit = true;
    this.showLoder = true;
    this.dataService.sendMail(this.name, this.email, this.message, this.type,  this.phone, this.topic).subscribe(
      (data) => {
        toastr.success('Message has been send successfully');
        this.submit = false;
        this.showLoder = false;
        this.mailData = data;
        this.name = '';
        this.email = '';
        this.message = '';
        this.phone = '';
        this.topic = '';
      },
      (error) => {
        toastr.error('Something went wrong, please try again later');
        this.submit = true;
        this.showLoder = false;
      }
    );

  }

  onlyNumeric(event: any): void {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }
}
